import React from 'react';
import { CommonDropdown } from "./CommonDropdown";
import {formatGroupLabel} from "root/ReactHookForm/ui/formatGroupLabelStandard";

const DropdownStaticEthnicity = ({ control, name, rules, placeHolder, isSearchable, isClearable, isMulti, readOnly, validate } ) =>
{
    const itemsbd = [
        {
            label: "White",
            options: [
                { label: "English, Welsh, Scottish, Northern Irish or British", value: 1 },
                { label: "Irish", value: 2 },
                { label: "Gypsy or Traveller", value: 3 },
                { label: "Roma", value: 19 },
                { label: "Any other White background", value: 4 },
            ]
        },
        {
            label: "Mixed or Multiple ethnic groups",
            options: [
                { label: "White and Black Caribbean", value: 5 },
                { label: "White and Black African", value: 6 },
                { label: "White and Asian", value: 7 },
                { label: "Any other Mixed or Multiple ethnic background", value: 8 },
            ]
        },
        {
            label: "Asian or Asian British",
            options: [
                { label: "Indian", value: 9 },
                { label: "Pakistani", value: 10 },
                { label: "Bangladeshi", value: 11 },
                { label: "Chinese", value: 18 },
                { label: "Any other Asian background", value: 12 },
            ]
        },
        {
            label: "Black, African, Caribbean or Black British",
            options: [
                { label: "African", value: 13 },
                { label: "Caribbean", value: 14 },
                { label: "Any other Black, African or Caribbean background", value: 15 },
            ]
        },
        {
            label: "Other ethnic group",
            options: [
                { label: "Arab", value: 16 },
                { label: "Any other ethnic group", value: 17 },
            ]
        },
    ];


    return (
        <CommonDropdown key={name} formatGroupLabel={formatGroupLabel} items={itemsbd} control={control} name={name} rules={rules} placeholder={placeHolder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} />
    )
}

export default DropdownStaticEthnicity;
